import { Fragment, useState, useContext, useRef } from 'react'
import { Transition } from '@headlessui/react'
import { useHistory } from "react-router-dom";
import Cta from '../components/Cta'
import AuthService from '../services/AuthService'
import { NotificationContext, useNotification } from '../providers/NotificationProvider';
import { useTheme } from '../providers/ThemeProvider'
import ReactGA from "react-ga4"

const formClass = "appearance-none block w-full px-8 py-4 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-primary text-login-form-input";
function FormInput(props) {
  var divStyle = "";

  return (
    <div className={divStyle}>
      <div className="">
        <input
          id={props.id}
          name={props.id}
          type={props.type}
          autoComplete={props.autocomplete || props.id}
          placeholder={props.placeholder || props.id}
          required={props.required}
					onClick={props.onClick }
          className=""
        />
      </div>
    </div>
  )
}

function SignInForm(props) {
  const [showForm, setShowForm] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const [ state, dispatch ] = useContext(NotificationContext);
  const [ theme, themeDispatch ] = useContext(NotificationContext);

  const notificationRef = useRef(null);
  const loadingBarRef = props.loadingBarRef;

  const submitLogin = (evt) => {
    evt.preventDefault();

    loadingBarRef.current.continuousStart();
    clearTimeout(notificationRef.current);
    dispatch({ type: "notification/hide" });

    AuthService.getTokenViaCredentials(username, password).then((response) => {
        loadingBarRef.current.complete();

        let login = response.data.data.login;
        let preferences = {
        }
        if (login.success === true) {
          dispatch({
            type: "notification/message",
            payload: {message: "Login Successful"}
          });

          //themeDispatch({ type: 'theme/set', payload: preferences });

          localStorage.setItem('AUTH_TOKEN', login.token)
          ReactGA.gtag("event", "login");

          //localStorage.setItem('preferences', JSON.stringify(preferences))

          dispatch({
            type: "notification/message",
            payload: { message: "HIGHLIGHT_PRODUCT_REQUEST_FEATURE" }
          });

          history.go('/marketplace');
        } else if (login.token) {
          dispatch({
            type: "notification/message",
            payload: {message: "New User Detected"}
          });

          history.go('/register?_ref=' + login.token);

        } else {
          notificationRef.current = setTimeout(() => {
            dispatch({ type: "notification/hide" });
          }, 5000);
          dispatch({
            type: "notification/error",
            payload: {message: login.message}
          });
        }
    });
  };

  return (
    <div className="mt-5 md:mt-10 mx-auto md:w-120">
      <div className="bg-white sm:rounded-lg">
        <form className="space-y-6" onSubmit={submitLogin} method="POST">
          <input
            id="email"
            type="email"
            placeholder="Email"
            value={username}
            onClick={() => setShowForm(true)}
            onChange={(e) => setUsername(e.target.value)}
            className={formClass}
            required
          />
      
      		<Transition
            show={showForm}
            className="space-y-4"
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
					>
            <input
              id="password"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={formClass}
              required
            />
            <div>
              <Cta style="style-2" label="Login" type="submit" />
            </div>
          </Transition>
        </form>
      </div>

    </div>
  )
}

export default SignInForm;
